import { useSessionStorage } from '@vueuse/core'

// TODO: use provide and inject instead of local/session storage for this
const BEARER_TOKEN_STORAGE_KEY = 'bearer-token'
// Bearer token for SPA authentication with mobile apps
export const mobileBearerToken = useSessionStorage<string | null>(
    BEARER_TOKEN_STORAGE_KEY,
    null
)
